<div class="row mt-4">
  <div class="col-lg-9">
    <div class="row">
      <div class="col-3"></div>
      <div class="col-6">
        <h5 style="color: #92929f; text-align: center;">Query Summary</h5>
      </div>
      <div class="col-3"></div>
    </div>
    <div class="row">
      <div class="col">
        <hr style="margin-top: 0px; border-color: #ffffff; color: #ffffff" />
        <h6 style="color: #92929f;">NHanes Data Sets</h6>
        <div style="padding: 10px 0 15px 0;">
          <kendo-chiplist>
            <kendo-chip *ngFor="let chip of selectedDataSetsFromLastRanQuery" [label]="chip.text" style="cursor: default; border-color: #333333; background-color: #333333; color: #ffffff">
            </kendo-chip>
          </kendo-chiplist>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <h6 style="color: #92929f;">Indication Details</h6>
        <div id="summarySectionDiv" style="padding: 10px 0 0 0;">
          <kendo-grid
            #summaryGrid
            id='summaryGrid'
            [sortable]="true"
            [kendoGridBinding]="summaryData"
            [resizable]="true"
            [pageable]="false"
          >
            <kendo-grid-column field="indication">
              <ng-template kendoGridHeaderTemplate let-dataItem>
                <span style="color: white;">Indication</span>
              </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="details">
              <ng-template kendoGridHeaderTemplate let-dataItem>
                <span style="color: white;">Selection Details</span>
              </ng-template>
              <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex" let-column="column">
                <ul style="list-style-type: none; padding: 2px; margin: 0;">
                  <li *ngFor="let item of dataItem.details">{{item}}</li>
                </ul>
              </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="inclusionCriteria">
              <ng-template kendoGridHeaderTemplate let-dataItem>
                <span style="color: white;">NHanes Inclusion Criteria</span>
              </ng-template>
              <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex" let-column="column">
                <ul style="list-style-type: none; padding: 2px; margin: 0;">
                  <li *ngFor="let item of dataItem.inclusionCriteria">{{item}}</li>
                </ul>
              </ng-template>
            </kendo-grid-column>
          </kendo-grid>
        </div>
    </div>
  </div>
</div>